// extracted by mini-css-extract-plugin
module.exports = {"Card":"card_Card__1Jhex"};